import React from 'react';
import styles from './style.module.scss';

export default function AiAvatarVideo() {
  return (
    <div className={styles.ai_tools_animation}>
      <img className={styles.ai_tools_animation_1} src={`${process.env.REACT_APP_BASENAME}/img/animations/animations-2-1.webp`} alt='' />
      <img className={styles.ai_tools_animation_2} src={`${process.env.REACT_APP_BASENAME}/img/animations/animations-2-2.webp`} alt='' />
      <img className={styles.ai_tools_animation_3} src={`${process.env.REACT_APP_BASENAME}/img/animations/animations-2-3.webp`} alt='' />
    </div>
  );
}
